<template>

  <div class="section d-flex">

    <div class="menu_section hidden-md-and-down"></div>
    <div class="container_section">

      <v-container>

        <v-breadcrumbs :items="breadcrumbs" class="pl-0 pb-0"></v-breadcrumbs>

        <h1 class="py-10">{{ $t('Charts') }}</h1>

        <logChart />

      </v-container>

    </div>
    
  </div>

</template>

<script>

// import { mapGetters } from "vuex";
import logChart from '@/components/charts/logChart' ;

export default {
  name: "Charts",

//   computed: {

//     ...mapGetters({
//       user: 'user/current'
//     })

//   },
  components: {
    logChart,
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: '/dashboard',
          exact: true
        },
        {
          text: 'Charts',
          disabled: true,
          exact: true
        },
      ]
    }
  },
  methods: {

  },
  created() {

  }

};
</script>
